import { Box, Typography } from '@mui/material';
import NorthIcon from '@mui/icons-material/North';
import roasProjections from '../../../../assets/icons/roas-projections-icon.svg';
import { useTheme } from '@mui/material/styles';
import { useMediaQuery } from '@mui/material';

const WeeklyPerformanceCard: React.FC<{
  selectedIndex: number;
  selectedWeekIndex: number;
  prevWeekIndex: number;
  overallPercentageChange: number;
}> = ({ selectedIndex, selectedWeekIndex, prevWeekIndex, overallPercentageChange }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box
      sx={{
        backgroundColor: '#2F736E',
        border: '1px solid #2F736E1F',
        padding: '1rem',
        borderRadius: '0.625rem',
        display: 'flex',
        flexDirection: isMobile ? 'column' : 'row',
        gap: '3rem',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: '1rem',
        }}
      >
        <img src={roasProjections} alt="roasProjections" />
        <Typography
          sx={{
            fontFamily: 'Manrope, sans-serif',
            fontWeight: 700,
            fontSize: '0.875rem',
            lineHeight: '1.25rem',
            color: '#F6F8F9',
            width: '5.5rem',
          }}
        >
          Change from last week
        </Typography>
        <Box
          sx={{
            backgroundColor: '#FFFFFF0D',
            borderRadius: '0.5rem',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            paddingRight: '0.25rem',
            paddingLeft: '0.5rem',
            border: '1px solid #E8EBFF99',
          }}
        >
          <Typography
            sx={{
              fontFamily: 'Manrope, sans-serif',
              fontWeight: 700,
              fontSize: '2rem',
              lineHeight: '2.75rem',
              color: selectedWeekIndex > prevWeekIndex ? '#E3EEC9' : '#FFD2CC',
              textShadow: `
                -1px -1px 0 #000,  
                1px -1px 0 #000,
                -1px 1px 0 #000,
                1px 1px 0 #000
                `,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {Math.abs(Math.round(overallPercentageChange))}%
            <NorthIcon
              sx={{
                fontSize: '2rem',
                fontWeight: 700,
                transform: selectedWeekIndex > prevWeekIndex ? 'rotate(0deg)' : 'rotate(180deg)',
                color: selectedWeekIndex > prevWeekIndex ? '#E3EEC9' : '#FFD2CC',
                stroke: '#000',
                strokeWidth: 1.5,
                paintOrder: 'stroke fill',
              }}
            />
          </Typography>
        </Box>
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'start',
          borderLeft: '2px solid #E8EAEB',
          paddingX: '1rem',
        }}
      >
        <Typography
          sx={{
            fontFamily: 'Manrope, sans-serif',
            fontWeight: 700,
            fontSize: '0.875rem',
            lineHeight: '1.25rem',
            color: '#F6F8F9',
          }}
        >
          Ad Index for week {selectedIndex + 2}
        </Typography>
        <Typography
          sx={{
            fontFamily: 'Manrope, sans-serif',
            fontWeight: 700,
            fontSize: '1rem',
            lineHeight: '1.575rem',
            color: '#F6F8F9',
          }}
        >
          {selectedWeekIndex}
        </Typography>
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'start',
          borderLeft: '2px solid #E8EAEB',
          paddingX: '1rem',
        }}
      >
        <Typography
          sx={{
            fontFamily: 'Manrope, sans-serif',
            fontWeight: 700,
            fontSize: '0.875rem',
            lineHeight: '1.25rem',
            color: '#F6F8F9',
          }}
        >
          Ad Index for week {selectedIndex + 1}
        </Typography>
        <Typography
          sx={{
            fontFamily: 'Manrope, sans-serif',
            fontWeight: 700,
            fontSize: '1rem',
            lineHeight: '1.575rem',
            color: '#F6F8F9',
          }}
        >
          {prevWeekIndex}
        </Typography>
      </Box>
    </Box>
  );
};

export default WeeklyPerformanceCard;
